var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-container text-center"},[_vm._m(0),_c('UserProfileInfo',{attrs:{"user":_vm.user}}),_c('RegionListToSelect',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('strong',{staticClass:"title"},[_vm._v("Add Regions to User")])])
}]

export { render, staticRenderFns }